import { render, staticRenderFns } from "./RouletteComponent.vue?vue&type=template&id=74052667&scoped=true&"
import script from "./RouletteComponent.vue?vue&type=script&lang=js&"
export * from "./RouletteComponent.vue?vue&type=script&lang=js&"
import style0 from "./RouletteComponent.vue?vue&type=style&index=0&id=74052667&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74052667",
  null
  
)

export default component.exports